const url = process.env.REACT_APP_API_URL;

export default class UserServices {


    static getUsers() {
        return fetch(`${url}/user`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static getUser(id) {
        return fetch(`${url}/user/${id}?id=${id}`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static getUserProfil(id) {
        return fetch(`${url}/profil/user`, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static addUser(user) {
        return fetch(`${url}/user`, {
            method: 'POST',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateUser(user) {
        return fetch(`${url}/user`, {
            method: 'PUT',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static deleteUser(user) {
        return fetch(`${url}/user`, {
            method: 'DELETE',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateUserRole(user) {
        return fetch(`${url}/user/${user.username}/change-role`, {
            method: 'PUT',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateUserPassword(user) {
        return fetch(`${url}/user/change-password`, {
            method: 'PUT',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateUserProfil(user) {
        return fetch(`${url}/user/change-profil`, {
            method: 'PUT',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static ForgetPassword(user) {
        return fetch(`${url}/user/forget-password`, {
            method: 'POST',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static ResetPassword(user) {
        return fetch(`${url}/user/reset-password/${user.token}`, {
            method: 'POST',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static Login(email, password) {
        return fetch(`${url}/login`, {
            method: 'POST',
            body: JSON.stringify({ email, password }),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static Logout(token) {
        return fetch(`${url}/logout`, {
            method: 'POST',
            body: JSON.stringify({ token }),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static handleError(error) {
        console.log(error);
    }


}